import { InjectionToken } from '@angular/core';
import {
    EditorialApprovalToggleInput,
    EditorialAssignmentsUpdateInput,
    EditorialCommentCreateInput,
    EditorialCreateInput,
    EditorialFilesAttachInput,
    EditorialIdVersionInput,
    EditorialMoveInput,
    EditorialSuggestionReviewInput,
    EditorialTaskToggleInput,
    EditorialTransitionInput,
    EditorialUpdateInput,
} from '@libs/types/src/services/input-type/editorial/editorial.input';
import { EditorialItem } from '@libs/types/src/services/editorial/editorial.types';
import { EditorialUserObject } from '@libs/types/src/services/object-type/editorial/editorial.object';

export interface EditorialApi {
    listEditorialItems(): Promise<EditorialItem[]>;
    listEditorialUsers(): Promise<EditorialUserObject[]>;
    createEditorialItem(input: EditorialCreateInput): Promise<EditorialItem>;
    updateEditorialItem(input: EditorialUpdateInput): Promise<EditorialItem>;
    updateEditorialAssignments(
        input: EditorialAssignmentsUpdateInput,
    ): Promise<EditorialItem>;
    moveEditorialItem(input: EditorialMoveInput): Promise<EditorialItem>;
    transitionEditorialItem(
        input: EditorialTransitionInput,
    ): Promise<EditorialItem>;
    toggleEditorialTask(
        input: EditorialTaskToggleInput,
    ): Promise<EditorialItem>;
    toggleEditorialApproval(
        input: EditorialApprovalToggleInput,
    ): Promise<EditorialItem>;
    reviewEditorialSuggestion(
        input: EditorialSuggestionReviewInput,
    ): Promise<EditorialItem>;
    addEditorialComment(
        input: EditorialCommentCreateInput,
    ): Promise<EditorialItem>;
    attachEditorialFiles(
        input: EditorialFilesAttachInput,
    ): Promise<EditorialItem>;
    syncEditorialWordpress(
        input: EditorialIdVersionInput,
    ): Promise<EditorialItem>;
    publishEditorialWordpress(
        input: EditorialIdVersionInput,
    ): Promise<EditorialItem>;
}

export const EDITORIAL_API = new InjectionToken<EditorialApi>('EditorialApi');
